// =============================================
// SHOPIFY CART TRANSFORM - FIX ADDON MULTIPLICATION
// Runs on server - 100% reliable
// =============================================

// This function runs every time something is added to cart
export default function cartTransform(inputCart) {
  const outputCart = {
    lines: [...inputCart.lines]
  };
  
  // Define your variants
  const BASE_VARIANT_ID = '45813952217285'; // No logo / No access
  const ADDON_VARIANTS = {
    '45813951824069': 'Logo/text_No access',
    '45813952020677': 'No logo_Full access',
    '45813951627461': 'Logo/text_Full access'
  };
  
  // Check each line in cart
  for (let i = 0; i < outputCart.lines.length; i++) {
    const line = outputCart.lines[i];
    const variantId = line.merchandise.id.toString();
    
    // If this is an addon variant with quantity > 1
    if (ADDON_VARIANTS[variantId] && line.quantity > 1) {
      const addonQuantity = line.quantity;
      
      // Replace this line with two lines:
      // 1. Base variant with correct quantity
      // 2. Addon variant with quantity 1
      
      outputCart.lines.splice(i, 1, {
        // Line 1: Base variant with full quantity
        merchandiseId: `gid://shopify/ProductVariant/${BASE_VARIANT_ID}`,
        quantity: addonQuantity,
        attributes: line.attributes
      }, {
        // Line 2: Addon variant with quantity 1
        merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
        quantity: 1,
        attributes: line.attributes
      });
      
      // Skip the line we just added
      i++; 
      
      console.log(`✅ Cart Transform: Split addon variant ${variantId} (qty ${addonQuantity}) into base + addon`);
    }
  }
  
  return outputCart;
}